import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useRef, useContext } from "react";
import ClockTimeLeft from "../../../Assets/Images/clockTimeLeft.png";
import { useReactMediaRecorder } from "react-media-recorder";
import { io } from "socket.io-client";
import PlayAudio from "react-simple-audio-player";
import chroma from "chroma-js";
import Countdown from "react-countdown";
import { timecoundFunc } from "../../../CustomHelper/timecoundFunc";
import { serverInfo } from "../../../App";

const colorScale = chroma.scale(["#0199CB", "#ffffff"]).mode("lch").colors(5);
const ChatHeadLock = ({ openMessenger, setOpenMessenger, data, chatData }) => {


  const { imageCdnUrl, videoCdnUrl, shoketUrl } = useContext(serverInfo);


  const [chatInfo, setChatInfo] = useState([]);
  const [starInfo, setStarInfo] = useState([]);
  const [qnaSessionRoom, setQnaSessionRoom] = useState("");
  const [recordUrl, setRecordUrl] = useState("");
  const [iconCng, setIconCng] = useState(false);
  const [msgData, setMsgData] = useState([]);
  const socket = useRef();
  const [text, setText] = useState("");
  const [recordStart, setRecordStart] = useState(true);
  const scrollRef = useRef();
  const [leftTime, setLeftTime] = useState();
  const [sendStatus, setSendStatus] = useState(true);
  //================ ====3rd party package===============================
  const { status, startRecording, stopRecording, mediaBlobUrl } =
    useReactMediaRecorder({ audio: true }, { type: "audio/mp3" });
  /**
   * socket connection
   */
  useEffect(() => {
    socket.current = io(shoketUrl);

    socket.current.emit("join_room", chatData.room_id);
    socket.current.on("qna_recive_message", (data) => {
      setMsgData((prv) => {
        return [...prv, data];
      });
    });

    axios
      .get(`/api/mobile/qna-chat-history/${chatData.room_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setMsgData(res.data.qna_history);
        }
      });
  }, []);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgData]);

  useEffect(() => {
    if (mediaBlobUrl) {
      setRecordUrl(mediaBlobUrl);
    }
  }, [mediaBlobUrl]);

  useEffect(() => {
    if (iconCng) {
      startRecording();
    } else {
      stopRecording();
      setRecordStart(true);
    }
  }, [iconCng]);

  function handleRecord() {
    setRecordStart(false);
    setIconCng((prev) => {
      return !prev;
    });
  }

  /**
   * send audio to server
   */
  const [buffer, setBuffer] = useState(false);
  const handleSend = async () => {
    setBuffer(true);
    getBase64FromUrl(mediaBlobUrl).then((data) => {
      let Arrybase64 = data.split(",");
      let base64 = Arrybase64[1];

      axios
        .post(`/api/mobile/only-media-upload`, {
          type: "video/mp3",
          base64: base64,
        })
        .then((res) => {
          setBuffer(false);
          if (res.data.status == 200) {
            // alert(res.data.path)
            sendToSocket(res.data.path);
          } else {
            alert("can't connect to server!");
          }
        });
    });
  };

  /**
   * base64 convert
   */
  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  /**
   * send info to soket server
   */
  const sendToSocket = (mediaUrl) => {
    let time =
      new Date(Date.now()).getHours() + ":" + new Date(Date.now()).getMinutes();
    let messageData = {
      sender_id: chatData?.user.id,
      room_id: chatData?.room_id,
      sender_name: chatData?.user.first_name,
      sender_image: chatData?.user.image,
      qna_id: chatData?.qna_id,
      msg_type: "audio",
      media: mediaUrl,
      text: null,
      time: time,
      status: 1,
    };

    socket.current.emit("qna_send_message", messageData);
    setMsgData((prv) => {
      return [...prv, messageData];
    });
  };

  const HandelTextsend = () => {
    let time =
      new Date(Date.now()).getHours() + ":" + new Date(Date.now()).getMinutes();
    let messageData = {
      sender_id: chatData?.user.id,
      room_id: chatData?.room_id,
      sender_name: chatData?.user.first_name,
      sender_image: chatData?.user.image,
      qna_id: chatData?.qna_id,
      msg_type: "text",
      media: null,
      text: text,
      time: time,
      status: 1,
    };

    socket.current.emit("qna_send_message", messageData);
    setMsgData((prv) => {
      return [...prv, messageData];
    });
    setText("");
  };

  const handleCancel = () => {
    stopRecording();
  };

  useEffect(() => {
    axios.get(`api/user/sinlgeQna/${data}`).then((res) => {
      if (res.data.status === 200) {
        setChatInfo(res.data.liveChat);
        setStarInfo(res.data.starInfo);
      }
    });

    axios.get(`api/user/qna/reg_info/${data}`).then((res) => {
      if (res.data.status === 200) {
        setQnaSessionRoom(res.data.event);
        if (res.data.event.publish_status === 0) {
          setSendStatus(false);
        }
      }
    });
  }, []);

  useEffect(() => {
    

    if (qnaSessionRoom) {
      let endTimeDate = moment(
        qnaSessionRoom?.qna_date.split(" ")[0] +
        " " +
        qnaSessionRoom?.qna_end_time
      );
      let startTimeDate = moment(
        qnaSessionRoom?.qna_date.split(" ")[0] +
        " " +
        qnaSessionRoom?.qna_end_time
      );

      let timeCount = endTimeDate.valueOf() - new Date(Date.now()).getTime();

      setLeftTime(timeCount);

      // let timeSecond = parseInt((timeCount / 1000) % 60)

     
    }
  }, [qnaSessionRoom]);

  

  // Renderer callback with condition
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      setSendStatus(false);
      return false;
    } else {
      // Render a countdown
      return (
        <span>
          {hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  return (
    <>
      <div className="dropDownParent">
        <div className="dropdown">
          {/* {openMessenger && ( */}
          <>
            <div className="messenger-menu">
              <div className="d-flex navBg">
                <i className="fa-solid fa-arrow-left-long backArrow flexBackArrow mt-1"></i>
                <h6 className="text-light fw-bold flexName px-2">
                  {starInfo?.first_name} {starInfo?.last_name}
                </h6>

                <i
                  onClick={() => setOpenMessenger(0)}
                  className="fa-solid fa-xmark backArrow flexBackArrow"
                ></i>
              </div>

              <div className="">
                <div className="timeLeftBg d-flex justify-content-around mx-3 my-3">
                  <div className="bg-dark clockTimeLeftBg d-flex justify-content-center align-items-center">
                    <img
                      src={ClockTimeLeft}
                      width="45px"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className=" d-flex justify-content-center align-items-center  mt-2">
                    <p className="text-light fw-bold bg-dark clockTimeLeftText p-2">
                      Time Left
                    </p>
                  </div>
                  <div className=" d-flex justify-content-center align-items-center  mt-2">
                    <p className="text-light fw-bolder bg-dark clockTimeLeftText py-2 px-4">
                      {leftTime ? (
                        <Countdown
                          date={Date.now() + leftTime}
                          renderer={renderer}
                        />
                      ) : (
                        "00 : 00 : 00"
                      )}
                    </p>
                  </div>
                </div>
                {/*=============> message body============>  */}
                {/* <div className="text-danger text-center">{status}</div> */}
                <div
                  style={{ height: 280, width: "100%", overflowY: "scroll" }}
                >
                  {msgData &&
                    msgData.map((item, index) => (
                      <div
                        className={`${item.sender_id === chatData.user.id
                          ? "d-flex justify-content-end my-2"
                          : "d-flex justify-content-start my-2"
                          }`}
                        ref={scrollRef}
                      >
                        <div className="mx-1 d-flex">
                          {item.sender_id !== chatData.user.id && (
                            <div
                              style={{
                                height: 30,
                                width: 30,
                                borderRadius: "100%",
                              }}
                            >
                              <img
                                style={{
                                  height: 30,
                                  width: 30,
                                  borderRadius: "100%",
                                  background: "#ffaa00",
                                }}
                                src={imageCdnUrl + item?.sender_image}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          )}

                          <div className="d-flex justify-content-center align-items-center mx-1">
                            {item.msg_type === "audio" ? (
                              <PlayAudio
                                colorScale={colorScale}
                                width={35}
                                url={videoCdnUrl + item?.media}
                              />
                            ) : (
                              <div
                                className={`d-flex justify-content-center align-items-center ${item.sender_id === chatData.user.id
                                  ? "bg-primary"
                                  : "bg-warning"
                                  }`}
                                style={{ borderRadius: 10, padding: 5 }}
                              >
                                <span className="text-light">{item?.text}</span>
                              </div>
                            )}
                          </div>

                          {item.sender_id === chatData.user.id && (
                            <div
                              style={{
                                height: 30,
                                width: 30,
                                borderRadius: "100%",
                              }}
                            >
                              <img
                                style={{
                                  height: 30,
                                  width: 30,
                                  borderRadius: "100%",
                                  background: "#ffaa00",
                                }}
                                src={imageCdnUrl + item?.sender_image}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>

                <div className="text-light bottomDiv d-flex justify-content-between align-items-center">
                  <div style={{ width: "100px" }}>
                    {text?.length <= 0 && (
                      <button
                        onClick={handleRecord}
                        className="d-flex p-2 justify-content-center align-items-center border-0 "
                      >
                        <i
                          className={`fa-solid fa-microphone  ${recordStart ? "text-primary" : "text-danger"
                            }`}
                          style={{ fontSize: 20 }}
                        ></i>
                        {/* <p className={`fw-bold m-2 ${recordStart ? 'text-primary' : 'text-danger'}`}>Record</p> */}
                      </button>
                    )}
                  </div>
                  <div className="" style={{ width: "350px" }}>
                    {/* <button onClick={handleRecord} className="micBg d-flex justify-content-center align-items-center mx-auto">
                      <i className={`fa-solid ${!iconCng ? ' fa-microphone' : 'fa-circle-pause'} microPhoneBg`}></i>
                    </button> */}
                    {recordStart && (
                      <input
                        type="text"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        className="form-control"
                        style={{ boxShadow: "none" }}
                      />
                    )}
                  </div>
                  {sendStatus ? (
                    <div style={{ width: "100px" }}>
                      {recordStart && (
                        <button
                          onClick={
                            text?.length > 0 ? HandelTextsend : handleSend
                          }
                          className="d-flex justify-content-center align-items-center border-0 p-2"
                        >
                          <i
                            className="fa-solid fa-paper-plane text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                          {/* <p className="text-dark fw-bold m-2">Send</p> */}
                        </button>
                      )}
                    </div>
                  ) : (
                    <div style={{ width: "100px" }}></div>
                  )}
                </div>

                {/* {play === 2 && (
                  <div className="text-light bottomDiv d-flex justify-content-center align-items-center">
                    <button onClick={handleStop} className="micBg d-flex justify-content-center align-items-center border-0">
                      <i className="fa-solid fa-play microPhoneBg"></i>
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </>
          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default ChatHeadLock;
